import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import FileCopy from '@material-ui/icons/FileCopy';
import Divider from '@material-ui/core/Divider';
import copy from 'copy-to-clipboard';

const EventsAndMetricsInfoDialog = (props) => {
  const values = [{
    label: 'Connection string',
    value: props.data.amqp_url || 'amqps://<user_name>:<password>@<ewm-instance-dn>:<port>/'
  }, {
    label: 'Exchange name',
    value: props.data.exchange || 't.<tenant-id>.x'
  }, {
    label: 'Queue patterns',
    value: props.data.queues_pattern || 't.<tenant-id>.q.<y>'
  }];

  const content = () => (
    <DialogContent>
      <div className="infrastructure-expanded">
        <div className="border">
          {dialogHeader()}
          {dialogBody()}
        </div>
      </div>
    </DialogContent>
  );

  const dialogHeader = () => (
    <h2 style={{marginTop: 0, marginBottom: 0, marginLeft: 15}}>
      Events and Metrics Integration Information
    </h2>
  );

  const dialogBody = () => (
    <List style={{flexDirection: 'column'}}>
      {values.map(item => listItem(item.label, item.value))}
      <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={false}>
        <ListItemText secondary={'Notes:' } className={'listItem-secondary-padding'} style={{ marginTop: 20 }} />
      </ListItem>
      <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={false}>
        <ListItemText style={{marginTop: -20}} secondary={props.data.info || '-'}/>
      </ListItem>
    </List>
  );

  const listItem = (label, value) => (
    <div>
      <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={false}>
        <ListItemText primary={label} secondary={value} className={'listItem-secondary-padding'} />
        <Tooltip title='Copy To Clipboard'>
          <IconButton style={{ opacity: 1, padding: 0, marginTop: 20 }} onClick={() => copy(value)}>
            <FileCopy color={'disabled'} style={{ width: 20, height: 20 }} />
          </IconButton>
        </Tooltip>
      </ListItem>
      <Divider style={{ marginLeft: 15, marginRight: 15, marginTop: -10 }} />
    </div>
  );

  const footerButtons = () => (
    <DialogActions style={{paddingLeft: '24px', paddingRight: '24px'}}>
      <Button onClick={() => props.updateDialog(false)}>Close</Button>
    </DialogActions>
  );

  return (
    <Dialog open={props.openDialog} className={'dialog-width'}>
      {content()}
      {footerButtons()}
    </Dialog>
  );
}

export default React.memo(EventsAndMetricsInfoDialog);
